import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Bot } from 'grts-utils/types/Bot';
import { api } from '../services/api';
import { GetTopAssetsByVolumeInfo } from '../../types/Bot';

interface BotState {
  activeBotId: number | null;
  botIds: Array<number>;
  bots: Record<number, Bot>;
  displayBots: Record<string, Array<GetTopAssetsByVolumeInfo>>;
  isDisplayBotsLoading: boolean;
}

const initialState: BotState = {
  activeBotId: null,
  botIds: [],
  bots: {},
  displayBots: {},
  isDisplayBotsLoading: true,
};

const botSlice = createSlice({
  name: 'bot',
  initialState,
  reducers: {
    setActiveBotId: (state, action: PayloadAction<number>) => {
      state.activeBotId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      api.endpoints.getBotIds.matchFulfilled,
      (state, { payload }) => {
        state.botIds = payload.botIds;
      },
    );

    builder.addMatcher(api.endpoints.getTopBots.matchPending, (state) => {
      state.isDisplayBotsLoading = true;
    });

    builder.addMatcher(
      api.endpoints.getTopBots.matchFulfilled,
      (state, { payload }) => {
        if (payload.assets) {
          state.displayBots = payload.assets;
          state.isDisplayBotsLoading = false;
        }
      },
    );
  },
});

export const { setActiveBotId } = botSlice.actions;

export const selectActiveBotId = (state: RootState) => state.bot.activeBotId;
export const selectDisplayBots = (state: RootState) => state.bot.displayBots;
export const selectIsDisplayBotsLoading = (state: RootState) =>
  state.bot.isDisplayBotsLoading;

export default botSlice.reducer;
